import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Hub, HubMode } from '@shared/models';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { InternalAnalyticsService } from '@shared/services/internalAnalytics.service';
import { OverlayContainer } from '@angular/cdk/overlay';
import { Router } from '@angular/router';
import { StripeBillingService } from '@shared/services/stripe-billing.service';

@Component({
  selector: 'hub-editor',
  templateUrl: './hub-edit.component.html',
  styleUrls: ['./hub-edit.component.scss']
})
export class HubEditComponent implements OnInit {
  hub: Hub;
  hubForm: FormGroup;
  planExpiredMessage: string = null;
  contactSalesMessage: string;
  isInTrial = false;
  trialDaysLeft = 0;
  planEndDate: Date;
  hubUsersTotal = 0;
  private stripeCustomerPortalUrl: string;
  public initialIndex: number;

  constructor(
    private _courseService: CoursesAPIService,
    private _dialogRef: MatDialogRef<HubEditComponent>,
    private _currentHubService: CurrentHubService,
    private _internalAnalyticsService: InternalAnalyticsService,
    private _overlayContainer: OverlayContainer,
    private _router: Router,
    private _billingService: StripeBillingService,
    @Inject(MAT_DIALOG_DATA) public data: { toTabIndex?: number }
  ) {
    this.initialIndex = data.toTabIndex;
    this.hubForm = new FormGroup({
      title: new FormControl('', { validators: [Validators.required, Validators.maxLength(50)] }),
      logo_id: new FormControl(''),
      properties: new FormGroup({
        displayWatermark: new FormControl(false)
      })
    });
  }

  ngOnInit(): void {
    this.hub = this._currentHubService.hub;
    this.hubForm.reset(this.hub);
    this.setPlanInfo(this.hub);
    if (this.hub.mode === HubMode.program) {
      this.initStripeCustomerPortal();
    }
  }

  setPlanInfo(hub: Hub) {
    this.isInTrial = this._currentHubService.isFree();
    if (this.isInTrial) {
      this.planExpiredMessage = `These options are not available with the ${hub.plan} plan.`;
    } else {
      this.planExpiredMessage = 'These options are not available with your plan.';
    }
    this.trialDaysLeft = this._currentHubService.planTimeLeft();
    this.planEndDate = this._currentHubService.planExpiration();
  }

  addLogoId(event: string): void {
    this.hubForm.controls['logo_id'].setValue(event);
  }

  save(): void {
    const properties = { ...this.hub.properties, displayWatermark: this.hubForm.controls.properties.value.displayWatermark };
    this._courseService.updateHub(this.hub.id, { title: this.hubForm.controls.title.value, logo_id: this.hubForm.controls.logo_id.value, properties }).subscribe(() => {
      this._dialogRef.close(true);
    });
  }

  contactSales(): void {
    this._internalAnalyticsService.showNewMessage();
  }

  isProgramHub(): boolean {
    return this.hub.mode === HubMode.program;
  }

  goToPlanSelection(): void {
    this._dialogRef.close(true);
    this._router.navigate(['plans', this.hub.urlTitle]);
  }

  async initStripeCustomerPortal(): Promise<void> {
    let resp: any;
    try {
      resp = await this._billingService.openStripeCustomerPortal({ hubId: this.hub.id }).toPromise();
      this.stripeCustomerPortalUrl = resp.url;
    } catch (e) {
      console.error('Stripe Customer Portal Init Error', e);
    }
  }

  launchStripeCustomerPortal(): void {
    window.location.href = this.stripeCustomerPortalUrl;
  }
}
